import { useTranslation } from 'react-i18next'
import manageState from './manageState';


import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import TableCustom from '../../../../components/table/tableCustom';
import { Employee } from '../../../../api/employee-cms/employee.api';
import { debouncedApiCall } from '../../../../utils/app.utils';
import { icons } from '../../../../assets/icons/icons';
import StateComponents from '../../../../components/state-component/StateComponents';

type Props = {
    code: string
}

const EmployeeList = ({ code }: Props) => {
    const {
        renderData,
        page,
        pageLimit,
        sortBy,
        sortType,
        headCell,
        totalItems,
        data,
        handleRequestSort,
        setPageLimit,
        setPage,
        checkPermit,
        setSearch,
        handleChangeDateRange,
        startDate,
        endDate,
    } = manageState({ code });

    const { t } = useTranslation();

    return (
        <div className='w-full'>
            <ContainerLayout
                // navigationList={
                //     <NavigateListCustom
                //         navigateData={[
                //             {
                //                 key: "HOME",
                //                 name: t("M.INFORMATION_SAP"),
                //                 pathName: RoutePath.home,
                //                 onClick: () => { }
                //             },
                //             {
                //                 key: "EMPLOYEE",
                //                 name: t("EMP.EMPLOYEE_INFORMATION"),
                //                 pathName: RoutePath.employee,
                //                 onClick: () => { }
                //             },
                //         ]}
                //     />
                // }
                // disabledContainerMargin
                // filterPropsOther={{
                //     spacingFilter: 2,
                //     sx: {
                //         mt: 2
                //     }
                // }}
                // filterPropsContent={[
                //   {
                //     seq: 1,
                //     type: 'TEXT_FIELD',
                //     gridProps: {
                //         xs: 12,
                //         md: 11.5
                //     },
                //     fieldProps: {
                //         startAdornment: <span className='mr-2'><icons.SearchNormal /></span>,
                //         onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                //         placeholder: t("EMP.SEARCH_EMPLOYEE_INFORMATION")
                //     }
                // },
                // ]}
                // buttonPropsContentCustom={

                // }
                // buttonPropsContent={[
                //     {
                //         seq: 1,
                //         mode: "pull-data",
                //         buttonName: t("EMP.PULL_EMPLOYEE_DATA"),
                //         onClick: () => handlePullEmployeeData(),
                //         type: "ADD",
                //         className: "mr-10px-i"
                //     },
                //     {
                //         seq: 2,
                //         mode: "add",
                //         buttonName: t("EMP.ADD_EMPLOYEE_DATA"),
                //         onClick: () => navigate(RoutePath.employeeAdd),
                //         type: "ADD",
                //     }
                // ]}
                title={t("จัดการบัญชีผู้ใช้เจ้าหน้าที่")}
                content={
                    <div style={{ display: 'flex', width: '100%', justifyContent: 'start', margin: '10px 0pc' }}>
                        <StateComponents
                        sxContainer={{width:'1000%'}}
                            otherProps={{
                                spacing: 2
                            }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        startAdornment: <span className='mr-4'><icons.SearchNormal /></span>,
                                        onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                                        placeholder: t("ค้นหาชื่อ"),
                                    }
                                },

                                {
                                    seq: 2,
                                    type: "DATE_RANGE2",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        handleChange: handleChangeDateRange,
                                        value: {
                                            end_date: endDate,
                                            start_date: startDate
                                        },
                                        placeholder: t("ช่วงวันที่"),
                                    }
                                },
                                // {
                                //     seq: 3,
                                //     type: "BUTTON",
                                //     gridProps: {
                                //         xs: 12,
                                //         md: 4
                                //     },
                                //     // hidden: !checkPermit.isCreated,
                                //     fieldProps: {
                                //         justifyContent: 'flex-end',
                                //         buttonData: [
                                //             {
                                //                 seq: 1,
                                //                 buttonProps: {
                                //                     onClick: () => navigate(routeName.cms_website.employeeAdd),
                                //                 },
                                //                 key: "ADD",
                                //                 label: "เพิ่มบัญชีผู้ใช้เจ้าหน้าที่",
                                //                 type: "ADD"
                                //             }
                                //         ]
                                //     }
                                // },
                            ]}
                        />

                        {/* <div>


                            <ContainerButton
                                buttonData={[
                                    // {
                                    //     seq: 1,
                                    //     hidden: !checkPermit.isCreated,
                                    //     buttonProps: {
                                    //         onClick: () => handlePullEmployeeData()
                                    //     },
                                    //     key: "HISTORY",
                                    //     label: t("EMP.PULL_EMPLOYEE_DATA"),
                                    //     type: "HISTORY"
                                    // },
                                    // {
                                    //     seq: 2,
                                    //     hidden: !checkPermit.isCreated,
                                    //     buttonProps: {
                                    //         disabled: isPending,
                                    //         onClick: () => startTransition(() => {
                                    //             handleExportExcel()
                                    //         })
                                    //     },
                                    //     key: "TEMPLATE_EXCEL",
                                    //     label: "ส่งออกข้อมูล",
                                    //     type: "TEMPLATE_EXCEL"
                                    // },
                                    // {
                                    //     seq: 3,
                                    //     hidden: !checkPermit.isCreated,
                                    //     buttonProps: {
                                    //         disabled: isPending,
                                    //     },
                                    //     onFileChange(file) {
                                    //         startTransition(() => {
                                    //             handleImportExcel(file)
                                    //         })

                                    //     },
                                    //     key: "IMPORT_EXCEL",
                                    //     label: "นำเข้าข้อมูล",
                                    //     type: "IMPORT_EXCEL"
                                    // },
                                    {
                                        seq: 4,
                                        // hidden: !checkPermit.isCreated,
                                        buttonProps: {
                                            onClick: () => navigate(routeName.cms_website.employeeAdd),
                                        },
                                        hidden: !checkPermit.isCreated,
                                        key: "ADD",
                                        label: t("เพิ่มบัญชีผู้ใช้เจ้าหน้าที่"),
                                        type: "ADD"
                                    },
                                ]}
                            />
                        </div> */}
                    </div>
                }
            />
            <section className='my-4'>
                {/* <StateComponents
                    otherProps={{ spacing: 2 }}
                    typeProps={[
                        {
                            seq: 1,
                            type: "AUTO-COMPLETE",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                getOptionLabel: (op) => op?.position_name || "",
                                labelId: "select_position",
                                placeholder: t("ตำแหน่งทั้งหมด"),
                                onChange: (_: any, value: any) => {
                                    if (value) {
                                        set_position(`${value?.id_position}`)
                                    } else {
                                        set_position("0")
                                    }
                                },
                                options: positionList || [],
                                value: positionList?.find((x: any) => x?.id_position == position) || null
                            }
                        },
                        {
                            seq: 2,
                            type: "AUTO-COMPLETE",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                getOptionLabel: (op) => op?.department_name || "",
                                labelId: "select_department",
                                placeholder: t("หน่วยงานทั้งหมด"),
                                onChange: (_: any, value: any) => value ? set_id_department(value) : set_id_department(null),
                                options: departmentList || [],
                                value: id_department || null
                            }
                        },
                    ]}
                /> */}
            </section>
            <section className='w-full'>
                <TableCustom
                    tableMinWidth={1920}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCell}
                    rowCount={totalItems}
                    rowsData={data?.map((data: Employee, i: number) => {
                        return renderData(data, i)
                    })}
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
        </div>
    )
}

export default EmployeeList